import { Component, Input, OnDestroy, OnInit } from '@angular/core'
import { UntypedFormArray, UntypedFormGroup } from '@angular/forms'
import { EthnicityService } from '@se-po/shared-data-access-services'
import { BaseValueAccessorDirective } from '@se-po/shared-ui-form-directives'
import { Observable, Subscription } from 'rxjs'
import { SeFeTranslationsLoader } from 'se-fe-translations'
import { Ethnicity } from 'se-resource-types/dist/lib/UserService'

@Component({
  selector: 'se-po-ethnicity-select',
  templateUrl: './ethnicity-select.component.html',
  styleUrls: ['./ethnicity-select.component.scss'],
  hostDirectives: [BaseValueAccessorDirective],
  standalone: false,
})
export class EthnicitySelectComponent implements OnInit, OnDestroy {
  @Input() public seFeDataLabel?: string

  public ethnicitiesLoaded = false
  public ngControl = BaseValueAccessorDirective.ngControl(this) // get the forwarded control
  public options: any
  public translationsLoaded = false

  private _subscriptions: Subscription[] = []

  constructor(private ethnicityService: EthnicityService,
              private seFeTranslationsLoader: SeFeTranslationsLoader
  ) { }

  public get form(): UntypedFormArray | UntypedFormGroup {
    return this.ngControl?.control?.parent
  }

  public get loaded(): boolean {
    return this.translationsLoaded && this.ethnicitiesLoaded
  }

  public ngOnInit(): void {
    this.initTranslations()
    this.initOptions()
  }

  public ngOnDestroy(): void {
    this._subscriptions.forEach(subscription => subscription.unsubscribe())
    this._subscriptions.length = 0
  }

  private initTranslations(): void {
    this.seFeTranslationsLoader.load('shared/ui-ethnicity-select/assets/translations').then(() => {
      this.translationsLoaded = true
    })
  }

  private initOptions(): void {
    this._subscriptions.push(
      this.getEthnicities().subscribe((ethnicityOptions: Ethnicity[])  => {
        const options = ethnicityOptions.map((ethnicityOption: Ethnicity) => ({
          text: ethnicityOption.name,
          value: ethnicityOption.id
        }))
        this.options = {
          sections: [{
            header: '',
            divider: false,
            options
          }]
        }
        this.ethnicitiesLoaded = true
      })
    )
  }

  private getEthnicities(): Observable<Ethnicity[]> {
    return this.ethnicityService.allEthnicities()
  }
}
